// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2xXqV","fileDisabled":"File_fileDisabled__3MJlb"};